'use client';

import React from "react";
import styles from './JobEligibilitySection.module.scss'
import { useModalDispatch } from "@/context/ModalContext";                                                                                                                                         
  import { IModalActions, ModalTypes } from '@/types/modal';                                                                                                                                      
  import { pushToDataLayer } from '@/helpers/gtag';                                                                                                                                              
  import { getGlobalStateValue, updateStateSession } from '@/context/utils'; 
  import popupData from '@/data/popup-data.json'; 

const EligibilityJobSection = ({ data, associatedPrograms }) => {

  if(!data)return null;
  if (!data) return null;

    const {
    Heading,
    LeftImage,
    RightContent,
    Note,
    ButtonText
  } = data;

  const modalDispatch = useModalDispatch();

   const handleCtaClick = () => {
      pushToDataLayer({                                                                                                                                                                                   
        event: 'lead_initiate',
        cta_text: ButtonText,
        section_name: 'job_eligibility_section',
        page_type: getGlobalStateValue('pageType'),                                                                                                                                                       
        page_url: window.location.href,
      });                                                                                                                                                                                                 
                  
      updateStateSession({
        parentSection: 'job_eligibility_section',
        leadStartingCta: ButtonText,                                                                                                                                                                      
      });
                                                                                                                                                                                                          
      modalDispatch({
        type: IModalActions.OpenModal,
        data: {
          modalType: ModalTypes.ConnectModalMba,
          modalData: {                                                                                                                                                                                    
            isLandingPage: true,
            popup: popupData, 
            associatedPrograms,
            isJobRole: true                                                                                                                                                                            
          },      
        },
      });
    };

  return (
    <div className={styles.mainContainer}>
        <div className={styles.headingContainer}>
        <h1>{Heading}</h1>
        <hr />
        </div>
    <div className={styles.contentContainer}>
        <div className={styles.imageContainer}>
            {LeftImage?.[0]?.url && (
                <img src={`${LeftImage?.[0]?.url}`} alt="Eligibility" />
            )}
        </div>
        <div className={styles.Rightcontent}>
            {RightContent?.map((item,ind)=>{
                return(
                    <div key={ind} className={styles.contentDiv}>
                    {item?.Image?.url && (
                        <img src={`${item?.Image?.url}`} alt={item.title} />
                    )}
                    <div className={styles.textContent}>
                    <h2>{item.title}</h2>
                    <p>{item.description}</p>
                    </div>
                </div>
                )
            })}
           
        <p className={styles.note}>
            {Note}
          </p>
        </div>
      </div>

      <div className={styles.buttonWrapper}>
        <button className={styles.checkBtn} onClick={handleCtaClick}>
          {ButtonText}
          <span className={styles.checkIcon}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <circle cx="10" cy="10" r="9" stroke="white" strokeWidth="1.5" />
              <path d="M6 10l3 3 5-5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
        </button>
      </div>
    </div>
  )
}

export default EligibilityJobSection
